import { Services } from '@sigma-frontend-libs/commons'

import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

function renderTitle(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value,
        label: this.getTranslate(`${Services.routingRules}.labels.title`),
        iconSVG: this.value.type,
        color: this.value.type,
        service: Services.routingRules,
        width: 'fit-content'
      }
    }
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: [ 'service-template-item', 'hover-parent', 'hover-parent--opacity' ]
    },
    [
      renderTitle.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
